import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
export default function SiteFooter() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="19753" id="site-footer" className="bg-secondary text-foreground py-24 px-8 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block">
              <img src="https://stunning-sculpin.10web.cloud/wp-content/uploads/2026/03/Minimalist-house-and-leaf-logo-1.png" alt="The Organized Space Logo" className="object-contain grayscale opacity-80 !w-[79px] !h-[100px] !rounded-3xl" />
            </Link>
            <p className="text-muted-foreground text-base leading-relaxed max-w-xs font-sans">Living Organized Bliss is a minimalist lifestyle blog dedicated to home organization, decluttering, and creating calm, functional living environments for modern families.</p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-base font-serif font-medium tracking-wide text-foreground">
              Discover
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/JournalPage" className="text-muted-foreground hover:text-accent-foreground transition-colors text-base font-sans">
                  The Journal
                </Link>
              </li>
              <li>
                <Link to="/ToolkitPage" className="text-muted-foreground hover:text-accent-foreground transition-colors text-base font-sans">
                  The Toolkit
                </Link>
              </li>
              <li>
                <Link to="/PhilosophyPage" className="text-muted-foreground hover:text-accent-foreground transition-colors text-base font-sans">
                  Our Philosophy
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-base font-serif font-medium tracking-wide text-foreground">
              Categories
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/JournalPage" className="text-muted-foreground hover:text-accent-foreground transition-colors text-sm font-sans">
                  Decluttering Guides
                </Link>
              </li>
              <li>
                <Link to="/JournalPage" className="text-muted-foreground hover:text-accent-foreground transition-colors text-sm font-sans">
                  Storage Solutions
                </Link>
              </li>
              <li>
                <Link to="/JournalPage" className="text-muted-foreground hover:text-accent-foreground transition-colors text-sm font-sans">
                  Minimalist Living
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-base font-serif font-medium tracking-wide text-foreground">
              Stay Connected
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground text-sm font-sans">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-accent-foreground/60" />
                <span>Seattle, WA & Beyond</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-sans">
                <Phone className="w-4 h-4 shrink-0 text-accent-foreground/60" />
                <span>(555) 987-6543</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-sans">
                <Mail className="w-4 h-4 shrink-0 text-accent-foreground/60" />
                <span>hello@theorganizedspace.com</span>
              </li>
            </ul>
            
            <div className="flex gap-4 pt-2">
              <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-accent-foreground hover:bg-accent/20 rounded-full" asChild>
                <Link to="#" aria-label="Facebook">
                  <Facebook className="w-4 h-4" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-accent-foreground hover:bg-accent/20 rounded-full" asChild>
                <Link to="#" aria-label="Twitter">
                  <Twitter className="w-4 h-4" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-accent-foreground hover:bg-accent/20 rounded-full" asChild>
                <Link to="#" aria-label="Instagram">
                  <Instagram className="w-4 h-4" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-accent-foreground hover:bg-accent/20 rounded-full" asChild>
                <Link to="#" aria-label="LinkedIn">
                  <Linkedin className="w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-border/40 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground font-sans tracking-wide">
          <p>&copy; {currentYear} The Organized Space. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>;
}